import { getPrefixRoute } from "../../../RBACPlugin";

const REACT_APP_EID_ADMIN_API_ENDPOINT = process.env.REACT_APP_EID_ADMIN_API_ENDPOINT;
const REACT_APP_API_ENDPOINT = REACT_APP_EID_ADMIN_API_ENDPOINT + "/api/v1/drivers";

const DRIVER_BASE_URL = REACT_APP_EID_ADMIN_API_ENDPOINT + "/api/v1";
const ORGANIZATION_DRIVER_BASE_URL = REACT_APP_EID_ADMIN_API_ENDPOINT + "/api/v1/org";


export default {

    GET_DRIVER_LIST:                         REACT_APP_API_ENDPOINT + "/list",
    CREATE_BUSINESS_DRIVER:                  REACT_APP_API_ENDPOINT + "/create",
    BUSINESS_VIEW_DRIVER_LIST:               REACT_APP_API_ENDPOINT + "/view",
    UPDATE_RIVER_STATUS:                     REACT_APP_API_ENDPOINT + "/update/status",
    VIEW_DRIVER_LIST:                        REACT_APP_API_ENDPOINT + "/view",
    LIST_DRIVER_FILTER:                      REACT_APP_API_ENDPOINT + "/list/filter",


    GET_DRIVER_LIST_BY_VEHICLE_UID:          REACT_APP_EID_ADMIN_API_ENDPOINT + "/api/v1/driver/list",
    GET_VIEW_DRIVER:                         DRIVER_BASE_URL + "/drivers/view",

    // organization drivers
    GET_ORGANIZATION_DRIVER_LIST:           ORGANIZATION_DRIVER_BASE_URL + "/users/list/search/drivers",

}